import { maxLength, ValidationField, Validator } from "~/extensions/utils";
export class AdminInformationFindConditionValidator extends Validator {
    constructor(data) {
        const constraints = {
            targetName: {
                length: maxLength(30)
            },
            subject: {
                length: maxLength(50)
            }
        };
        super(data, constraints);
        this.targetName = new ValidationField("targetName", data, constraints);
        this.subject = new ValidationField("subject", data, constraints);
    }
    targetName;
    subject;
}
